import { PreviewEditTemplateActions } from "../../../../../ngapp/src/app/preview-edit-template/state/preview-edit-template.actions";
angular
    .module("autoremind.templates", ["angularFileUpload"])
    .factory("templateService", [
    "$enhancedHttp",
    "jobService",
    "$timeout",
    "dialogs",
    "Upload",
    "$uibModal",
    "$rootScope",
    "$q",
    "$httpQueue",
    "accountService",
    "$filter",
    "$location",
    "userSettings",
    "storeDowngraded",
    "previewEditTemplateSelectorsDowngraded",
    'eventSharingService',
    function ($enhancedHttp, jobService, $timeout, dialogs, $upload, $modal, $scope, $q, $httpQueue, accountService, $filter, $location, userSettings, storeDowngraded, previewEditTemplateSelectorsDowngraded, eventSharingService) {
        /**
         * Fields deleted from DB model due template editing
         */
        var deletedFields = [];
        const TYPE = {
            ALL: "all",
            COMMUNICATIONS: "communications",
            AUTOREMIND: "autoremind",
        };
        return {
            loadingIndicator: {
                refCount: 0,
                state: true,
            },
            userModel: {
                userId: null,
                templates: [],
                userCategorys: [],
                loadingIndicator: {
                    refCount: 0,
                    state: false,
                },
            },
            // Used in Images only
            previewModel: {
                inDb: {},
                inFile: {},
                previewMessages: {
                    mailContent: null,
                    voiceContent: null,
                    templateFileNameForPreview: null,
                    isNeedToUse: false,
                    loadingIndicator: {
                        refCount: 0,
                        state: false,
                    },
                },
            },
            clonedTemplateModel: null,
            imageModel: null,
            availableCategorys: [
                {
                    type: "",
                    name: "-- Choose category -- ",
                    value: "",
                },
                {
                    type: TYPE.ALL,
                    name: "-- All categories -- ",
                    value: "all",
                },
                {
                    type: TYPE.ALL,
                    name: "-- Enabled features -- ",
                    value: "enabled",
                },
                {
                    type: TYPE.COMMUNICATIONS,
                    name: "Birthday messages (Communications)",
                    value: "birthday",
                },
                {
                    type: TYPE.COMMUNICATIONS,
                    name: "Late Payment (Communications)",
                    value: "latepayment",
                },
                {
                    type: TYPE.COMMUNICATIONS,
                    name: "Missed Appointment (Communications)",
                    value: "missed",
                },
                {
                    type: TYPE.COMMUNICATIONS,
                    name: "Triggered Message (Communications)",
                    value: "triggered",
                },
                {
                    type: TYPE.COMMUNICATIONS,
                    name: "Newsletter (Communications)",
                    value: "newsletter",
                },
                {
                    type: TYPE.COMMUNICATIONS,
                    name: "Recalls (Communications)",
                    value: "recalls",
                },
                {
                    type: TYPE.COMMUNICATIONS,
                    name: "Sale (Communications)",
                    value: "sale",
                },
                {
                    type: TYPE.COMMUNICATIONS,
                    name: "Seasonal Greetings (Communications)",
                    value: "seasonal",
                },
                {
                    type: TYPE.COMMUNICATIONS,
                    name: "Short Notice (Communications)",
                    value: "shortnotice",
                },
                {
                    type: TYPE.COMMUNICATIONS,
                    name: "Survey (Communications)",
                    value: "survey",
                },
                {
                    type: TYPE.COMMUNICATIONS,
                    name: "Reviews (Communications)",
                    value: "reviews",
                },
                {
                    type: TYPE.AUTOREMIND,
                    name: "Reminder",
                    value: "reminder",
                },
                {
                    type: TYPE.AUTOREMIND,
                    name: "Two-way Texting",
                    value: "twoway",
                },
            ],
            availableTemplateTypes: [
                {
                    name: "Communications",
                    value: "communications",
                },
                {
                    name: "Autoremind",
                    value: "autoremind",
                },
            ],
            templateParameters: [
                {
                    label: "firstname",
                    name: "person.firstName",
                },
                {
                    label: "lastname",
                    name: "person.lastName",
                },
                {
                    label: "company",
                    name: "account.companyName",
                },
            ],
            model: {
                userTemplates: [],
                currentUser: null,
                currentTemplate: null,
                isLoading: false,
                autoremind2: {
                    lastIndex: 0,
                    templates: [],
                },
                autoremind3: {
                    lastIndex: 0,
                    templates: [],
                    isCanLoad: true,
                },
                newRegisterdTemplate: null,
                userFoldersPattern: /^[0-9]+\/.+$/g,
            },
            availableLanguage: [
                {
                    name: "--Select Langauge",
                    value: "all",
                },
                {
                    name: "English (AU)",
                    value: "en-au",
                },
                {
                    name: "English (US)",
                    value: "en-us",
                },
                {
                    name: "English (UK)",
                    value: "en-uk",
                },
                {
                    name: "Danish (Danish)",
                    value: "da-dk",
                },
                {
                    name: "Spanish (US)",
                    value: "es-us",
                }
            ],
            activeTabOfMessages: "email",
            setActiveTabOfMessages: function (media) {
                this.activeTabOfMessages = media;
            },
            /**
             * Add field to the list for delete from DB model
             */
            addDeletedField: function (field) {
                deletedFields.push(field);
            },
            getCategorys: function (type) {
                var tmp = [];
                for (var i in this.availableCategorys) {
                    var category = this.availableCategorys[i];
                    if ((category.value === "enabled" || category.value === "all") &&
                        type === "template") {
                        continue;
                    }
                    if (category.value === "enabled" && !this.model.currentUser) {
                        continue;
                    }
                    tmp.push(category);
                }
                return tmp;
            },
            getTemplatesUrlByFilters: function () {
                var url = "/servlets/templates/all/";
                url +=
                    "?offset=" +
                        userSettings.model.ar3filters.offset +
                        "&sortby=" +
                        userSettings.model.ar3filters.sortby +
                        "&order=" +
                        (userSettings.model.ar3filters.order ? "desc" : "asc") +
                        "&category=" +
                        (userSettings.model.ar3filters.category === "enabled"
                            ? "all"
                            : userSettings.model.ar3filters.category) +
                        "&name=" +
                        userSettings.model.ar3filters.name +
                        "&file=" +
                        userSettings.model.ar3filters.file +
                        "&displayDefault=" +
                        userSettings.model.ar3filters.displayDefault +
                        "&userId=" +
                        (this.userModel.userId ? this.userModel.userId : 0) +
                        "&language=" +
                        userSettings.model.ar3filters.language;
                return url;
            },
            getTemplates: function () {
                //console.log('getTemplates', this.userModel.userId);
                if (!this.model.autoremind3.isCanLoad)
                    return;
                var self = this;
                var url = this.getTemplatesUrlByFilters();
                //scrolling is called multiple times and makes loading slower. So we need to check if its already in progress
                // and if it is we should not call it until its finished (for  angular JS)
                if (!self.model.isLoading) {
                    self.model.isLoading = true;
                    $httpQueue({
                        method: "GET",
                        headers: { "Content-Type": "application/json" },
                        url: url,
                        errorMessage: "Failed getting templates from server.",
                        disableErrorDialog: false,
                        retryBtn: true,
                        stacking: {
                            label: "getTemplates",
                            isActive: true,
                            type: "byfilters",
                        },
                    }, this.loadingIndicator).then(function (data) {
                        //self.model.autoremind3.templates = [];
                        //console.log('byfilters', data);
                        if (angular.isDefined(data.rejectedFromQueue) &&
                            data.rejectedFromQueue) {
                            return;
                        }
                        self.model.isLoading = false;
                        for (var i = 0; i < data.templatesAll.length; i++) {
                            var exist = false;
                            for (var x in self.model.autoremind3.templates) {
                                if (self.model.autoremind3.templates[x].templateId ===
                                    data.templatesAll[i].templateId) {
                                    exist = true;
                                    //console.log('exist');
                                    break;
                                }
                            }
                            if (exist) {
                                continue;
                            }
                            data.templatesAll[i].sending = false;
                            data.templatesAll[i].editingTemplate = false;
                            data.templatesAll[i].isEdited = false;
                            self.model.autoremind3.templates.push(data.templatesAll[i]);
                        }
                        if (angular.isDefined(data.templateGetLimit)) {
                            userSettings.model.ar3filters.offset += parseInt(data.templateGetLimit);
                        }
                        if (angular.isDefined(data.templateGetLimit) &&
                            data.templatesAll.length < data.templateGetLimit) {
                            self.model.autoremind3.isCanLoad = false;
                        }
                        self.model.autoremind3.lastIndex = data.templatesAll.length;
                        if (self.clonedTemplateModel) {
                            self.addClonedToTemplates();
                        }
                    }, function (err) {
                        self.model.isLoading = false;
                    });
                }
            },
            addClonedToTemplates: function () {
                for (var i in this.model.autoremind3.templates) {
                    if (this.clonedTemplateModel.templateId ===
                        this.model.autoremind3.templates[i].templateId) {
                        return;
                    }
                }
                this.model.autoremind3.templates.push(this.clonedTemplateModel);
                var self = this;
                $timeout(function () {
                    self.clonedTemplateModel = null;
                }, 500);
            },
            enabledFeaturesFilter: function (item) {
                if (!this.model.currentUser ||
                    userSettings.model.ar3filters.category !== "enabled") {
                    return item;
                }
                if (this.userModel.userCategorys.indexOf(item.communicationsCategoryId) !== -1) {
                    return item;
                }
            },
            hidingFilter: function (template) {
                if (userSettings.model.ar3filters.displayDefault) {
                    var defaultFound = !template.templateName.toLowerCase().match(/^\d/) &&
                        template.templateFileRef.toLowerCase().indexOf('default') === 0;
                    if (!defaultFound) {
                        return;
                    }
                }
                if (userSettings.model.ar3filters.hideOtherUsersTemplates) {
                    var found = template.templateFileRef.match(this.model.userFoldersPattern);
                    if (found !== null) {
                        if (!this.model.currentUser) {
                            return;
                        }
                        // Check if the userId of current user is included in the filename - to not filter those out
                        found =
                            template.templateFileRef.indexOf("" + this.model.currentUser) >=
                                0;
                        if (!found) {
                            return;
                        }
                    }
                }
                if (this.model.currentUser &&
                    userSettings.model.ar3filters.hideAssignedTemplates &&
                    template.countOfCurrentUserMappings > 0) {
                    return;
                }
                if (this.model.currentUser &&
                    userSettings.model.ar3filters.hideNotMappedForCurrent &&
                    template.countOfCurrentUserMappings === 0) {
                    return;
                }
                if (userSettings.model.ar3filters.hideLinkedAnyUsers &&
                    (template.countOfTemplateFileUsages > 0 ||
                        template.countOfCurrentUserMappings > 0)) {
                    return;
                }
                return template;
            },
            getLanguage: function (type) {
                var tmp = [];
                for (var i in this.availableLanguage) {
                    var language = this.availableLanguage[i];
                    tmp.push(language);
                }
                return tmp;
            },
            resetFilters: function (isFull) {
                if (isFull) {
                    userSettings.model.ar3filters.category = "all";
                    userSettings.model.ar3filters.sortby = "templateDisplayName";
                    userSettings.model.ar3filters.name = "";
                    userSettings.model.ar3filters.file = "";
                    userSettings.model.ar3filters.language = "all";
                }
                if (angular.isUndefined(userSettings.model.ar3filters.language)) {
                    userSettings.model.ar3filters.language = "all";
                }
                userSettings.model.ar3filters.offset = 0;
                this.model.autoremind3.templates.length = 0;
                this.model.autoremind3.isCanLoad = true;
                this.model.currentTemplate = null;
                // this.clonedTemplateModel = null;
                this.getTemplates();
            },
            addTemplateToTemplates: function (template) {
                var templateData = angular.copy(template);
                templateData.sending = false;
                templateData.editingTemplate = false;
                templateData.isEdited = false;
                this.model.autoremind3.templates.push(templateData);
            },
            getTemplatesByUserId: function () {
                //console.log('getTemplatesByUserId', this.userModel.userId);
                var self = this;
                var url = "/servlets/templates/" + this.userModel.userId + "/";
                $enhancedHttp({
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                    url: url,
                    errorMessage: "Failed getting user templates from server!",
                    disableErrorDialog: false,
                    retryBtn: true,
                }, this.userModel.loadingIndicator).then(function (data) {
                    self.userModel.templates = [];
                    self.userModel.userCategorys = [];
                    if (!angular.isDefined(data.templates)) {
                        return;
                    }
                    self.setUserTemplates(data.templates);
                    //                self.userModel.templates = data.templates;
                }, function (err) {
                    console.log("some error", err);
                });
            },
            setUserTemplates: function (templates) {
                for (var i in templates) {
                    if (this.userModel.userCategorys.indexOf(templates[i].communicationsCategoryId) === -1) {
                        this.userModel.userCategorys.push(templates[i].communicationsCategoryId);
                    }
                    templates[i].isSetMaster = false;
                    templates[i].isSetEnabled = false;
                    templates[i].sending = false;
                    this.userModel.templates.push(templates[i]);
                }
            },
            removeUserTemplate: function (template) {
                var self = this;
                dialogs
                    .confirm("Warning", "Removing this template from this user may cause problems if already used for active communication jobs or reminder strategies. Are you sure you want to remove?")
                    .result.then(function () {
                    self.confirmRemoveUserTemplate(template, true);
                }, function () {
                    return;
                });
            },
            confirmRemoveUserTemplate: function (template, isForce) {
                var self = this;
                var url = "/servlets/templates/" +
                    template.templateId +
                    "/" +
                    this.userModel.userId +
                    "/";
                url += isForce ? "?force=true" : "";
                $enhancedHttp({
                    method: "DELETE",
                    headers: { "Content-Type": "application/json" },
                    url: url,
                    errorMessage: "Failed removing template from server",
                    disableErrorDialog: true,
                    retryBtn: false,
                }, this.userModel.loadingIndicator).then(function (data) {
                    if (angular.isDefined(data.rowsDeleted) && data.rowsDeleted > 0) {
                        self.getTemplatesByUserId();
                    }
                }, function (err) { });
            },
            setTemplateToUser: function (isClone, template, isForce, isMaster) {
                if (!angular.isDefined(template.templateId) ||
                    !this.model.currentUser ||
                    (!angular.isDefined(template.isSystemMaster) &&
                        !angular.isDefined(template.isMaster))) {
                    return;
                }
                template.sending = true;
                var self = this;
                var url = "";
                if (isClone) {
                    var url = "/servlets/templates/" +
                        template.templateId +
                        "/" +
                        this.model.currentUser +
                        "/clone/";
                }
                else {
                    var url = "/servlets/templates/" +
                        template.templateId +
                        "/" +
                        this.model.currentUser +
                        "/";
                    url += isForce ? "?force=true" : "?force=false";
                }
                var isUserMaster = typeof isMaster !== "undefined"
                    ? isMaster
                    : angular.isDefined(template.isSystemMaster)
                        ? template.isSystemMaster
                        : template.isMaster;
                var isEnabled = angular.isDefined(template.isEnabled)
                    ? template.isEnabled
                    : true;
                $httpQueue({
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    url: url,
                    data: {
                        userId: parseInt(this.model.currentUser),
                        templateId: parseInt(template.templateId),
                        isUserMaster: isUserMaster,
                        isEnabled: isEnabled,
                        language: null,
                        forTwilio: false
                    },
                    errorMessage: "Error saving the data ",
                    disableErrorDialog: false,
                    stacking: {
                        label: "setTemplateToUser",
                        isActive: true,
                        type: template.communicationsCategoryId,
                    },
                }).then(function (data) {
                    if (angular.isDefined(data.rejectedFromQueue) &&
                        data.rejectedFromQueue) {
                        template.sending = false;
                        if (angular.isDefined(template.isSetMaster))
                            template.isSetMaster = false;
                        if (angular.isDefined(template.isSetEnabled))
                            template.isSetEnabled = false;
                        //console.log('rejectedFromQueue', new Date().getTime());
                        return;
                    }
                    if (angular.isDefined(data.templateCloned)) {
                        data.templateCloned.countOfMappings = 0;
                        self.addTemplateToTemplates(data.templateCloned);
                    }
                    if (isClone && angular.isDefined(data.templateCloned)) {
                        self.clonedTemplateModel = data.templateCloned;
                    }
                    if (angular.isDefined(data.rejectedInUse) && data.rejectedInUse) {
                        if (angular.isDefined(data.templateCloned)) {
                            self.confirmSetTemplateToUserIsMaster(data.templateCloned);
                            template.sending = false;
                            return;
                        }
                        self.confirmSetTemplateToUserIsMaster(template);
                        return;
                    }
                    self.getTemplatesByUserId();
                    template.sending = false;
                    if (angular.isDefined(template.isSetMaster))
                        template.isSetMaster = false;
                    if (angular.isDefined(template.isSetEnabled))
                        template.isSetEnabled = false;
                }, function (err) {
                    //console.log(err);
                    self.getTemplatesByUserId();
                    template.sending = false;
                    if (angular.isDefined(template.isSetMaster))
                        template.isSetMaster = false;
                    if (angular.isDefined(template.isSetEnabled))
                        template.isSetEnabled = false;
                    if (isClone) {
                        self.showCloneErrorDialog();
                    }
                });
            },
            confirmSetTemplateToUserIsMaster: function (template) {
                var self = this;
                dialogs
                    .confirm("Warning", "The template you have just assigned is by default set at master while you have another template of the same category (" +
                    template.communicationsCategoryId +
                    ") set as master. Are you sure you want this change (cancel to keep the previous template as master)?")
                    .result.then(function () {
                    //Yes
                    self.setTemplateToUser(false, template, true, true);
                }, function () {
                    //No
                    self.setTemplateToUser(false, template, true, false);
                });
            },
            changeTemplate: function (template, forRevert, isConfirmed) {
                template.editingTemplate = true;
                var url = "/servlets/templates/" + template.templateId + "/";
                var force = angular.isDefined(isConfirmed) ? "?force=true" : "";
                url += force;
                var self = this;
                var dataToRequest = this.findEditedTemplateFields(template, forRevert);
                console.log("dataToRequest", dataToRequest, typeof template, typeof forRevert);
                dataToRequest.lastModified = moment(forRevert.lastModified)
                    .toDate()
                    .getTime();
                dataToRequest.previous = this.prepareTemplateDataToSending(forRevert);
                dataToRequest.userId = this.userModel.userId
                    ? this.userModel.userId
                    : null;
                //console.log('dataToRequest', dataToRequest);
                $enhancedHttp({
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    url: url,
                    data: dataToRequest,
                    errorMessage: "Error changing the data ",
                    disableErrorDialog: true,
                }).then(function (data) {
                    template.editingTemplate = false;
                    template.isEdited = false;
                    if (angular.isDefined(data.status) &&
                        data.status.rejectedMappedToAnotherUser) {
                        template.countOfMappings = 1;
                        self.revertAndUpdateEditedTemplate(template, forRevert, {});
                        self.showRejectedMappedDialog();
                        return;
                    }
                    if (angular.isDefined(data.status) &&
                        (data.status.rejectedInUse || data.status.rejectedModified)) {
                        var editedFields = self.findEditedTemplateFields(data.template, forRevert, true);
                        self.confirmChangingTemplate(template, forRevert, editedFields, data.status);
                        return;
                    }
                    // update selected template with template from db
                    for (var x in data.template) {
                        template[x] = data.template[x];
                        self.model.currentTemplate[x] = data.template[x];
                    }
                    for (var i in self.userModel.templates) {
                        if (self.userModel.templates[i].templateId === template.templateId) {
                            self.getTemplatesByUserId();
                            break;
                        }
                    }
                    if (data.updatedTemplateSize > 0) {
                        var msg = 'The template path is changed from ' + data.templateFrom + ' to ' + data.templateTo + ' in total of ' + data.updatedTemplateSize + ' template(s). Do you want to delete file from server ' + data.templateFrom;
                        dialogs.confirm("Editing of template", msg).result.then(function () {
                            self.cancelUploadTemplateFile(data.templateFrom, false);
                        }, function () {
                            deferred.reject();
                        });
                    }
                }, function (err) {
                    template.editingTemplate = false;
                    template.isEdited = false;
                    self.revertAndUpdateEditedTemplate(template, forRevert, {});
                });
            },
            revertAndUpdateEditedTemplate: function (template, forRevert, editedFields) {
                for (var i in this.userModel.templates) {
                    if (this.userModel.templates[i].templateId === template.templateId) {
                        this.getTemplatesByUserId();
                        break;
                    }
                }
                for (var i in forRevert) {
                    if (angular.isDefined(editedFields[i])) {
                        template[i] = editedFields[i];
                    }
                    else {
                        template[i] = forRevert[i];
                    }
                }
                return;
            },
            cloneToTwilio: function (template) {
                var self = this;
                var url = "/servlets/templates/" +
                    template.templateId +
                    "/" +
                    self.userModel.userId +
                    "/cloneAsTwilio/";
                $enhancedHttp({
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    url: url,
                    data: {
                        userId: parseInt(this.model.currentUser),
                        templateId: parseInt(template.templateId),
                        isUserMaster: false,
                        isEnabled: true,
                        language: template.language,
                        forTwilio: true
                    },
                    errorMessage: "Failed in cloning template as Twilio from server",
                    disableErrorDialog: true,
                    retryBtn: false,
                }, self.userModel.loadingIndicator).then(function (data) {
                    self.getTemplatesByUserId();
                }, function (err) { });
            },
            findEditedTemplateFields: function (newTemplate, oldTemplate, isNeedParse) {
                var modfyedFields = {};
                for (var i in newTemplate) {
                    if (i === "sending" ||
                        i === "editingTemplate" ||
                        i === "isEdited" ||
                        i === "createdDate" ||
                        i === "lastModified") {
                        continue;
                    }
                    if (oldTemplate[i] !== newTemplate[i]) {
                        if (!isNeedParse || i !== "templateDefaultContent") {
                            modfyedFields[i] = newTemplate[i];
                            continue;
                        }
                        var templateDefaultContentNew = JSON.parse(newTemplate[i]);
                        var templateDefaultContentOld = JSON.parse(oldTemplate[i]);
                        for (var x in templateDefaultContentNew) {
                            if (templateDefaultContentOld[x] !== templateDefaultContentNew[x]) {
                                modfyedFields["template." + x] = templateDefaultContentNew[x];
                            }
                        }
                    }
                }
                return modfyedFields;
            },
            showRejectedMappedDialog: function () {
                dialogs.notify("Editing of template", "Editing is not possible. The template is already assigned to at least one user.");
            },
            showErrorIfFileIsUsed: function () {
                var deferred = $q.defer();
                var msg = "";
                if (this.userModel.userId) {
                    msg =
                        "This exact path and filename is already registered at least once and assigned to other users. Do you want to upload as a custom template for the user?";
                    dialogs.confirm("Editing of template", msg).result.then(function () {
                        deferred.resolve();
                    }, function () {
                        deferred.reject();
                    });
                }
                else {
                    msg =
                        "This exact path and filename is already registered at least once and assigned to at least one user. Replacing not allowed!";
                    dialogs.notify("Editing of template", msg);
                    $timeout(function () {
                        deferred.reject();
                    });
                }
                return deferred.promise;
            },
            /**
             * Update template.templateDefaultContent if there are some fields marked for removing from DB model
             */
            updateModel: function (template) {
                if (deletedFields.length === 0) {
                    return template;
                }
                var DBmodel = JSON.parse(template.templateDefaultContent);
                var DBmodelUpdated = {};
                for (var key in DBmodel) {
                    if (deletedFields.indexOf(key) < 0) {
                        DBmodelUpdated[key] = DBmodel[key];
                    }
                }
                template.templateDefaultContent = JSON.stringify(DBmodelUpdated);
                deletedFields = [];
                return template;
            },
            confirmChangingTemplate: function (template, forRevert, editedFields, status) {
                var self = this;
                var dialog = dialogs.create("app/dialog/templates-of-dialogs/confirm.editing.template.dialog.html", "autoremind.dialogs.confirmEditingTemplateController", { editedFields: editedFields, status: status }, { key: false, back: "static" });
                dialog.result
                    .then(function () {
                    return self.updateModel(template);
                })
                    .then(function (templateUpdated) {
                    self.doSaveTemplateDialogConfirm(templateUpdated, forRevert);
                })
                    .catch(function (error) {
                    console.log("confirmChangingTemplate error", error);
                    self.doSaveTemplateDialogCancel(template, forRevert, editedFields);
                });
            },
            doSaveTemplateDialogConfirm: function (template, forRevert) {
                console.log("Template will be updated");
                this.changeTemplate(template, forRevert, true);
            },
            doSaveTemplateDialogCancel: function (template, forRevert, editedFields) {
                this.revertAndUpdateEditedTemplate(template, forRevert, editedFields);
            },
            prepareTemplateDataToSending: function (template) {
                var tmp = angular.copy(template);
                delete tmp.editingTemplate;
                delete tmp.isEdited;
                delete tmp.sending;
                return tmp;
            },
            uploadTemplate: function (template, isCustomTemplate) {
                var deferred = $q.defer();
                var modalInstance;
                var modalScope = $scope.$new();
                var self = this;
                modalScope.template = angular.isDefined(template) ? template : {};
                modalScope.isCustomTemplate = isCustomTemplate;
                modalScope.success = function () {
                    modalInstance.close(modalScope.selected);
                    self.checkNewTemplate();
                    deferred.resolve();
                };
                modalScope.cancel = function () {
                    modalInstance.dismiss("cancel");
                    deferred.reject();
                };
                modalInstance = $modal.open({
                    template: "<template-upload></template-upload>",
                    size: "lg",
                    backdrop: "static",
                    scope: modalScope,
                });
                return deferred.promise;
            },
            checkNewTemplate: function () {
                if (!this.clonedTemplateModel) {
                    return;
                }
                var dataForFiltering = {
                    communicationsCategoryId: userSettings.model.ar3filters.category === "all"
                        ? ""
                        : userSettings.model.ar3filters.category,
                    templateDisplayName: userSettings.model.ar3filters.name,
                    templateFileRef: userSettings.model.ar3filters.file,
                    language: userSettings.model.ar3filters.language,
                };
                if (!this.enabledFeaturesFilter(this.clonedTemplateModel) ||
                    !this.hidingFilter(this.clonedTemplateModel) ||
                    !$filter("orderBy")(this.clonedTemplateModel, userSettings.model.ar3filters.sortby, userSettings.model.ar3filters.order) ||
                    $filter("filter")([this.clonedTemplateModel], dataForFiltering)
                        .length === 0) {
                    this.askToReloadResetFilters();
                    return;
                }
                for (var i in this.model.autoremind3.templates) {
                    if (this.model.autoremind3.templates[i].templateId ===
                        this.clonedTemplateModel.templateId) {
                        return;
                    }
                }
                this.model.autoremind3.templates.push(this.clonedTemplateModel);
            },
            askToReloadResetFilters: function () {
                var self = this;
                dialogs
                    .confirm("Newly template", "The newly registered template is not visible with the current filters. Do you want to reset the filters?")
                    .result.then(function () {
                    self.resetFilters(true);
                }, function () {
                    return;
                });
            },
            uploadTemplateFile: function (file) {
                //console.log(file);
                return $upload.upload({
                    url: "/servlets/templates/upload/",
                    data: {
                        fileName: file.alias,
                    },
                    file: file,
                });
            },
            cancelUploadTemplateFile: function (fileName, shouldUseTmpFolder) {
                var url = "/servlets/templates/deletefile/";
                return $enhancedHttp({
                    method: "DELETE",
                    headers: { "Content-Type": "application/json" },
                    url: url,
                    data: {
                        fileName: fileName,
                        shouldUseTmpFolder: shouldUseTmpFolder,
                    },
                    errorMessage: "Error of canceling uploading",
                    disableErrorDialog: true,
                });
            },
            cancelUploadImageFile: function (fileName) {
                var url = "/servlets/templates/deleteimage/";
                return $enhancedHttp({
                    method: "DELETE",
                    headers: { "Content-Type": "application/json" },
                    url: url,
                    data: {
                        fileName: fileName
                    },
                    errorMessage: "Error canceling upload",
                    disableErrorDialog: true,
                });
            },
            checkIsFileValid: function (tmpFileName, loadingIndicator) {
                var url = "/servlets/templates/checksyntax/?fileName=" + tmpFileName;
                return $enhancedHttp({
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                    url: url,
                    errorMessage: "Error checking the template syntax",
                    disableErrorDialog: true,
                }, loadingIndicator);
            },
            registerTemplate: function (data, loadingIndicator) {
                var url = "/servlets/templates/new/";
                var self = this;
                data.isConfirm =
                    data.templateDisplayName.toLowerCase().indexOf("confirm") !== -1
                        ? true
                        : false;
                return $enhancedHttp({
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    url: url,
                    data: data,
                    errorMessage: "Error registering the template",
                    disableErrorDialog: true,
                }, loadingIndicator).then(function (res) {
                    if (data.isMapToUser) {
                        self.setUserTemplates([res.template]);
                    }
                    return res;
                });
            },
            checkFileExistence: function (fileName, templateName, category, language, loadingIndicator) {
                var url = "/servlets/templates/checkexistence/?fileName=" +
                    fileName +
                    "&templateName=" +
                    templateName +
                    "&category=" +
                    category +
                    "&language="
                    + language;
                return $enhancedHttp({
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                    url: url,
                    errorMessage: "Error check if the template file already exists",
                    disableErrorDialog: true,
                }, loadingIndicator);
            },
            downloadTemplate: function (templateName) {
                if (!angular.isDefined(templateName) || templateName === "") {
                    return;
                }
                var url = "/servlets/templates/download/?fileName=" + templateName;
                var fileName = templateName.substring(templateName.lastIndexOf("/") + 1);
                var click_ev = document.createEvent("MouseEvents");
                click_ev.initEvent("click", true, true);
                var anchor = angular.element("<a/>");
                anchor
                    .attr({
                    href: url,
                    target: "_self",
                    download: fileName,
                })[0]
                    .dispatchEvent(click_ev);
            },
            cloneTemplate: function (templateId) {
                var self = this;
                var url = "/servlets/templates/" + templateId + "/clone/";
                return $enhancedHttp({
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    url: url,
                    errorMessage: "Error cloning the template",
                    disableErrorDialog: true
                }).then(function (res) {
                    if (angular.isDefined(res.templateCloned)) {
                        self.clonedTemplateModel = res.templateCloned;
                    }
                    return res;
                }, function (err) {
                    self.showCloneErrorDialog();
                    return err;
                });
            },
            showCloneErrorDialog: function () {
                dialogs.notify("Error", "Error creating clone of template registration");
            },
            fileNameGuideDialog: function () {
                var msg = '<ol class="guide-dialog">' +
                    "<li>Avoid revision numbers in filenames. If editing the file and uploading again it should have the same name</li>" +
                    "<li>Avoid spaces, upper case letters and special characters - these may be handled differently on various systems</li>" +
                    "<li>Prefix with the category and - (e.g. sale-xmas.html) makes it easier to know the category just from the filename</li>" +
                    "<li>Prefix template name with user ID if registration is using a template file not inside the user's folder but with modified model to make it clear that the registration is for a specific user (rather than registering an exact copy of the template file into the user's folder)</li>" +
                    "<li>Use camel case (lowerCaseFirstWord) or dashes in stead of spaces template names</li>" +
                    "</ol>";
                dialogs.notify("Template Naming", msg);
            },
            replaceTemplate: function (data, loadingIndicator) {
                var url = "/servlets/templates/replacefile/";
                return $enhancedHttp({
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    url: url,
                    data: data,
                    errorMessage: "Error replacing the template ",
                    disableErrorDialog: true,
                }, loadingIndicator);
            },
            editTemplateModelDialog: function (templateModel, fileModel, isOnlyPreview, canEditDefault) {
                var deferred = $q.defer();
                var self = this;
                // This is called when we upload a template and preview
                if (fileModel !== undefined && fileModel !== false) {
                    fileModel.templateFileRef = fileModel.alias;
                }
                isOnlyPreview = isOnlyPreview !== undefined ? isOnlyPreview : false;
                console.log(accountService.getSelectedUser());
                var testUserName = accountService.getSelectedUser() !== null && accountService.getSelectedUser() !== undefined
                    ? accountService.getSelectedUser().userName
                    : undefined;
                var testUserId = this.userModel.userId
                    ? this.userModel.userId
                    : undefined;
                console.log(eventSharingService.hasPermission(['admin:template:editdefault']));
                console.log(!templateModel.templateName.toLowerCase().match(/^\d/));
                console.log(templateModel.templateFileRef.toLowerCase().indexOf('default') === 0);
                canEditDefault = canEditDefault ? eventSharingService.hasPermission(['admin:template:editdefault']) &&
                    !templateModel.templateName.toLowerCase().match(/^\d/) &&
                    templateModel.templateFileRef.toLowerCase().indexOf('default') === 0
                    : canEditDefault;
                storeDowngraded.dispatch(PreviewEditTemplateActions.openPreviewEditTemplateDialog({
                    templateModel,
                    fileModel,
                    isOnlyPreview,
                    testUserName,
                    testUserId,
                    canEditDefault
                }));
                var subscribe = previewEditTemplateSelectorsDowngraded
                    .selectGetSavedCustomTemplate()
                    .subscribe(function (response) {
                    if (response) {
                        self.getTemplatesByUserId();
                    }
                });
                var subscribe2 = previewEditTemplateSelectorsDowngraded
                    .selectGetModel()
                    .subscribe(function (response) {
                    // This is required for Communication only
                    if (response.media !== undefined && isOnlyPreview) {
                        var template = angular.copy(response);
                        angular.forEach(template.media, function (v, k) {
                            v.templateId = response.templateId;
                        });
                        template.mediaTypes = {};
                        template.mediaTypes.media = template.media;
                        var job = jobService.createDefaultJob(template);
                        jobService.setCurrentJob(job, true);
                        deferred.resolve({
                            templateCloned: templateModel,
                        });
                    }
                });
                return deferred.promise;
            },
            // TODO: Check if we are using it in communication controller now
            // getModelContentByTemplateId: function (templateId, loadingIndicator) {
            //   if (!loadingIndicator) {
            //     loadingIndicator = this.loadingIndicator;
            //   }
            //   var url = "/servlets/templates/" + templateId + "/modelcontent/";
            //
            //   return $enhancedHttp(
            //     {
            //       method: "POST",
            //       headers: { "Content-Type": "application/json" },
            //       url: url,
            //       errorMessage: "Error getting template model from server",
            //       disableErrorDialog: false,
            //     },
            //     loadingIndicator
            //   );
            // },
            // used in image-upload
            preprocessModel: function (mediaType, model) {
                var url = "/servlets/templates/preprocess/" + mediaType + "/";
                return $enhancedHttp({
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    url: url,
                    data: model,
                    errorMessage: "Error preprocessing the template ",
                    disableErrorDialog: true,
                });
            },
            selectUploadImagesDialog: function (config, model, file) {
                var deferred = $q.defer();
                var modalInstance;
                var modalScope = $scope.$new();
                modalScope.model = model ? angular.copy(model) : {};
                modalScope.model.file = file;
                modalScope.config = config ? config : {};
                // modalScope.templateFileName = templateFileName;
                modalScope.success = function (result) {
                    modalInstance.close(modalScope.selected);
                    deferred.resolve(result);
                };
                modalScope.cancel = function () {
                    modalInstance.dismiss("cancel");
                    deferred.reject();
                };
                modalInstance = $modal.open({
                    template: "<upload-select-images></upload-select-images>",
                    size: "lg",
                    scope: modalScope,
                    backdrop: "static",
                });
                return deferred.promise;
            },
            previewImage: function (imageUrl) {
                if (!angular.isDefined(imageUrl) || !imageUrl)
                    return;
                var modalInstance;
                var modalScope = $scope.$new();
                modalScope.imageUrl = decodeURIComponent(imageUrl);
                modalScope.success = function (result) {
                    modalInstance.close(modalScope.selected);
                };
                modalScope.cancel = function () {
                    modalInstance.dismiss("cancel");
                };
                modalInstance = $modal.open({
                    template: "<preview-image></preview-image>",
                    size: "lg",
                    scope: modalScope,
                });
            },
            checkImageNameOnExistence: function (imageName, userFolder) {
                var url = "/servlets/templates/checkimagenameandexistence/?fileName=" +
                    encodeURIComponent(imageName) + "&userFolder=" + userFolder;
                return $enhancedHttp({
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                    url: url,
                    errorMessage: "Error checking if image name is correct and if it exist on the server already",
                    disableErrorDialog: true,
                });
            },
            useImages: function (model) {
                var url = "/servlets/templates/useimage/";
                return $enhancedHttp({
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    url: url,
                    data: model,
                    errorMessage: "Error using the image",
                    disableErrorDialog: true,
                });
            },
            setImageModel: function (imageModel) {
                this.imageModel = [];
                for (var i in imageModel) {
                    var model = {
                        file: null,
                        fileUploadProgress: 0,
                        varName: imageModel[i].ngModel,
                        src: imageModel[i].src,
                    };
                    this.imageModel.push(model);
                }
            },
            dirstructure: function (path, loadingIndicator) {
                var url = "/servlets/templates/dirstructure/?path=" + path;
                return $enhancedHttp({
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                    url: url,
                    errorMessage: "Error getting the list of images on the server",
                    disableErrorDialog: true,
                }, loadingIndicator);
            },
            clearModel: function () {
                this.model.userTemplates = [];
                this.model.currentUser = null;
                this.model.autoremind2.lastIndex = 0;
                this.model.autoremind2.templates = [];
                this.model.autoremind3.lastIndex = 0;
                this.model.autoremind3.templates = [];
            },
            showUsersListForTemplate: function (template) {
                var deferred = $q.defer();
                var modalInstance;
                var modalScope = $scope.$new();
                modalScope.templateId = template.templateId;
                modalScope.templatesType = "ar3";
                modalScope.templateFileRef = template.templateFileRef;
                modalScope.success = function (user) {
                    modalInstance.close(modalScope.selected);
                    $location.search("userid", user.userId);
                    deferred.resolve();
                };
                modalScope.cancel = function () {
                    modalInstance.dismiss("cancel");
                    deferred.reject();
                };
                modalInstance = $modal.open({
                    template: "<users-list-for-template></users-list-for-template>",
                    size: "lg",
                    scope: modalScope,
                    backdrop: "static",
                });
                return deferred.promise;
            },
            getUsersListByTemplateId: function (templateFileRef, templateId, loadingIndicator) {
                var url = "/servlets/templates/assignedusersfortemplate/?templateFileRef=" + templateFileRef + "&templateId=" + templateId;
                return $enhancedHttp({
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                    url: url,
                    errorMessage: "Error getting the list of users on the server",
                    disableErrorDialog: true,
                }, loadingIndicator);
            },
            removePrefixTemplateFromModel: function (model) {
                return Object.keys(model).reduce(function (modelNew, modelKey) {
                    const cleanKey = modelKey.replace(/template./g, "");
                    return Object.assign(Object.assign({}, modelNew), { [cleanKey]: model[modelKey] });
                }, {});
            },
        };
    },
]);
//# sourceMappingURL=templates.services.js.map